var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93555 14.5L3.90714 13.4611C5.30102 14.8723 7.23701 15.4221 9.37725 15.4221C13.6234 15.4221 17.0656 11.9799 17.0656 7.7338C17.0656 5.6279 16.2189 3.71975 14.8474 2.3312L15.8187 1.50003M9.79269 15.4221V18.5M9.79269 18.5H5.22126M9.79269 18.5H14.1563M13.9355 7.50003C13.9355 10.2615 11.697 12.5 8.93555 12.5C6.17412 12.5 3.93555 10.2615 3.93555 7.50003C3.93555 4.73861 6.17412 2.50003 8.93555 2.50003C11.697 2.50003 13.9355 4.73861 13.9355 7.50003Z",
    stroke: "#0E1111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 8.00017L7.66732 9.83351L11.6673 5.83334",
    stroke: "#0E1111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.3d1a1ccbabc8501aec775c9505b2e903.svg";
export { ForwardRef as ReactComponent };